import React from 'react';
import Image, { IImage } from 'tbk-components/src/components/Image';

/**
 * Full Width Image
 * @block
 * @requiresHooks
 * @icon format-image
 */
const WullWidthImage: React.FC<IImage> = (props) => (
	<Image className="full-width-image" {...props} />
);

export default WullWidthImage;
